import type { JSX } from "react";

export const AnalyticsEmptyState = (): JSX.Element => {
  return (
    <div className="flex min-h-80 flex-1 items-center justify-center rounded-xl border border-(--border-color) bg-(--bg-light) px-6 py-12 text-center text-[0.95rem] text-(--text-secondary)">
      No analytics data for the selected date range.
    </div>
  );
};
